import { duration, DurationInputArg1, unitOfTime } from 'moment';
import { SelectOptionElement } from '@odin-labs/components';
import {
  CCureEntityMapping,
  CCureEntitySelectOptionElement,
  HidEntityOption,
  HidFargoSelectOptionElement,
  BadgeTemplateOptionElement,
  BadgeTemplate,
  FormOptionElement,
  UserForm,
  JobsiteUser,
} from 'containers/jobsiteConfiguration/types';
import { getUserFullName } from 'utils';

export { toggleBorderClasses } from 'components/utils';
export { languageOptions } from 'containers/selfOnboarding/utils';

export const getAsDurationString = (
  value: DurationInputArg1,
  unit?: unitOfTime.DurationConstructor,
): string => value && duration(value, unit).toISOString();

export const getCCureEntityMappingsOptions = (
  entityMappings: CCureEntityMapping[],
  appendNamespaceToLabel = true,
): CCureEntitySelectOptionElement[] =>
  entityMappings?.map((cem) => ({
    value: `${cem.cCureEnvironment?.namespace}:${cem.objectId}`,
    label: appendNamespaceToLabel
      ? `${cem.name} [${cem.cCureEnvironment?.namespace}]`
      : cem.name,
    entity: cem,
  })) ?? [];

export const getHidFargoEntityOptions = (
  entityOptions: HidEntityOption[],
  typeName: string,
): HidFargoSelectOptionElement[] => {
  return entityOptions
    .filter((entity) => entity.entityType.includes(typeName))
    ?.map((entity) => ({
      value: entity.id,
      label: `${entity.name} [${
        typeName.includes('Printer')
          ? entity.locationName
          : entity.proxyInstance
      }]`,
      entity,
    }));
};

export const getBadgeTemplateOptions = (
  badgeTemplates: BadgeTemplate[],
  isForTempBadge: boolean,
): BadgeTemplateOptionElement[] =>
  badgeTemplates
    ?.filter((bt) => bt.isForTempBadge === isForTempBadge)
    .map((badgeTemplate) => ({
      value: badgeTemplate.id,
      label: badgeTemplate.displayName,
      badgeTemplate,
    })) ?? [];

export const getSchedulerOptions = (
  jobsiteUsers: JobsiteUser[],
): SelectOptionElement[] =>
  jobsiteUsers
    ?.map((ju) => ({
      value: ju.userAccountId,
      label: getUserFullName(ju),
    }))
    .sort((a, b) => a.label.localeCompare(b.label)) ?? [];

export const getFormOptions = (forms: UserForm[]): FormOptionElement[] => {
  return (
    forms?.map((form) => ({
      value: form.id,
      label: form.name,
      key: form.key,
      description: form.description,
      allowSessionAssignment: form.allowSessionAssignment,
      allowAutoCreateOnCheckout: form.allowAutoCreateOnCheckout,
    })) ?? []
  );
};
